import { Directive, EventEmitter, HostListener, Output } from "@angular/core";
import { fromEvent, Subscription } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Directive({
    standalone: true,
    selector: "[appPureClick]"
})
export class PureClickDirective {
    @Output() appPureClick = new EventEmitter<MouseEvent>();
    private subscription: Subscription | null = null;

    @HostListener("mousedown", ["$event"])
    onMouseDown(event: MouseEvent) {
        const mouseMove$ = fromEvent<MouseEvent>(document, "mousemove");
        const mouseUp$ = fromEvent<MouseEvent>(document, "mouseup");

        this.subscription = mouseMove$.pipe(takeUntil(mouseUp$)).subscribe((moveEvent) => {
            if (Math.abs(moveEvent.clientX - event.clientX) > 5 || Math.abs(moveEvent.clientY - event.clientY) > 5) {
                this.cleanup();
            }
        });

        mouseUp$.subscribe(() => {
            if (this.subscription) {
                this.appPureClick.emit(event);
                this.cleanup();
            }
        });
    }

    private cleanup(): void {
        this.subscription?.unsubscribe();
        this.subscription = null;
    }
}
